(function() {
  'use strict';

  angular
    .module('admin.versions.service', [])
    .factory('VersionsService', VersionsService);

  /** @ngInject */
  function VersionsService($http, $q, API) {

    function list(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'version')
          .success(defered.resolve);

        return defered.promise;
    }

    return{
       list: list
    };

  }

})();
